import { CorporateAddress } from '../../entity/corporate/corprateAddress';
import { CorporateState } from '../../entity/corporate/corporateState';
import { EVStationBranch } from '../../entity/corporate/corporateDetails';

export class CorporateStateTransformer {
    transform(stateInfo: any) : CorporateState {
        return new CorporateState(
            stateInfo.code,
            stateInfo.description
        )
    }

    deTransform(state: CorporateState) : any {
        return {
            code: state.code,
            description: state.name
        }
    }
}
export class CorporateAddressTransformer {
    transform(addressInfo: any) : CorporateAddress {    
        let stateInfo = addressInfo.state
        return new CorporateAddress(
            addressInfo.addressLine1,
            addressInfo.addressLine2,
            addressInfo.addressLine3,
            addressInfo.landmark,
            addressInfo.city,
            stateInfo ? new CorporateState(stateInfo.code, stateInfo.description) : new CorporateState(""),
            addressInfo.pincode
        )        
    }

    deTransform(address: CorporateAddress) : any {
        return {
            addressLine1: address.line1,
            addressLine2: address.line2,
            addressLine3: address.line3,
            landmark: address.landmark,
            city: address.city,
            state: new CorporateStateTransformer().deTransform(address.state),
            pincode: address.zipcode
        }
    }
}
export class BranchTransformer {
    transform(branchInfo: any) : EVStationBranch {
        return new EVStationBranch (
            branchInfo.corporateId,
            branchInfo.corporateName,
            branchInfo.branchId,
            branchInfo.branchName,
            branchInfo.status
        )
    }
}